import { useFilters } from "./useFilters";

export const usePaginator = (stateSelector, dispatchCallback) => {
  const [filters, updateFilters] = useFilters(stateSelector, dispatchCallback);
  const setPage = (page) => updateFilters({ page });

  return [filters, setPage] as const;
};
